export enum TCaseMethodologyStepIcons {
  NONE = 'none',
  ORDERED_LIST = 'ordered-list',
  FACE_GRIN = 'face-grin-outline',
  EDIT_OUTLINE = 'edit-outline',
  CLOCK_ARROW = 'clock-arrow',
  CHEVRON_DOUBLE_RIGHT = ' chevron-double-right',
}
